import { useLocalization } from '@bumble/localization/components';
import { applyUrl, aboutUrl, faqUrl } from 'lib/constants';

import { clickEventFromElement } from 'components/google-analytics/google-analytics';

export function useMenu(props: any) {
    const Localization = useLocalization();

    if (props.menu && props.menu.edges.length > 0) {
        const menuList = props.menu.edges
            .filter(
                // for now we filter only header-menu
                (menuListItem: any) => menuListItem.node.name === 'header-menu'
            )[0]
            .node.menuItems.edges.filter(
                // we filter only top level item
                (menuListItemMenuItem: any) => menuListItemMenuItem.node.parentId === null
            )
            // show only node item
            .map((menuItem: any) => {
                return {
                    id: menuItem.node.id,
                    // @TODO: translate in future?
                    text: menuItem.node.label,
                    uri: menuItem.node.uri,
                    order: menuItem.node.order,
                    seo: {
                        name: 'click',
                        category: 'bumble-honey-ambassadors Navigation',
                        action: 'Button Click Header',
                        label: 'Apply link',
                    },
                    onClick: (event: React.MouseEvent<HTMLAnchorElement>) =>
                        clickEventFromElement(event),
                };
            })
            .sort((itemA: any, itemB: any) => itemA.order > itemB.order);

        return menuList.filter((item: any) => item);
    }

    const DEFAULT_MENU = [
        {
            id: 'about-item',
            text: Localization.get('bumblesite@team_bumble.page_index.navigation.links.about'),
            uri: aboutUrl,
            seo: {
                name: 'click',
                category: 'bumble-honey-ambassadors Navigation',
                action: 'Button Click Header',
                label: 'About link',
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement>) => clickEventFromElement(event),
        },
        {
            id: 'faq-item',
            text: Localization.get('bma_client@pages.faq.section.items.faq'),
            uri: faqUrl,
            seo: {
                name: 'click',
                category: 'bumble-honey-ambassadors Navigation',
                action: 'Button Click Header',
                label: 'FAQs link',
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement>) => clickEventFromElement(event),
        },
        {
            id: 'apply-item',
            text: Localization.get('bumblesite@team_bumble.page_open_roles.apply_now.cta'),
            uri: applyUrl,
            seo: {
                name: 'click',
                category: 'bumble-honey-ambassadors Navigation',
                action: 'Button Click Header',
                label: 'Apply link',
            },
            onClick: (event: React.MouseEvent<HTMLAnchorElement>) => clickEventFromElement(event),
        },
    ];

    return DEFAULT_MENU.filter((item) => item);
}
